<template>
  <v-app>
    <div :class="{'d-print-none': isPrintMode}">
      <v-app-bar app dark>
        <v-app-bar-nav-icon @click="onNavIconClick" :class="{'d-md-none': showFilters}"></v-app-bar-nav-icon>
        <v-toolbar-title class="d-flex align-center">
          <v-img :src="appIcon" height="64px" width="64px" contain />
          <div class="ml-2 d-flex flex-column justify-center">
            <span class="text-h6 font-weight-black mb-0 pa-0">
              {{appTitle}}
            </span>
            <span class="text-caption font-weight-light text-uppercase mt-0 pa-0">
              {{appSubTitle}}
            </span>
          </div>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn class="ml-1" icon small @click="onToggleDarkMode" title="Alto contraste">
          <v-icon>mdi-brightness-6</v-icon>
        </v-btn>

        <v-btn class="ml-1" icon small @click="onShowInfo" title="Sobre...">
          <v-icon>mdi-information</v-icon>
        </v-btn>

        <template v-slot:img>
          <tj-tool-bar-bg centered :is-dark="darkMode" secondary="#000d33" primary="#440066" />
        </template>
      </v-app-bar>

      <v-main style="min-height:calc(100vh - 64px - 86px)" :class="{'d-print-none': showSentenca}"> 
        <v-container>
          <v-card outlined elevation="1">
            
            <tj-app ref="app" @view="onViewItem"  @state-change="onStateChange" />

          </v-card>
        </v-container>
      </v-main>

      <v-toolbar dark color="#003471" elevation="0" height="86px">
        <div class="d-flex justify-center" style="width:100%;">
          <a href="https://www.tjpa.jus.br" title="Tribunal de Justiça do Estado do Pará">
            <v-img src="/img/logo-tjpa.png" contain width="200px" />
          </a>
        </div>
        <template v-slot:img>
          <tj-tool-bar-bg centered :is-dark="darkMode" primary="#172542" secondary="#020710" />
        </template>
      </v-toolbar>

      <tj-sentenca-dialog 
        v-model="showSentenca" 
        :content-class="{'d-print-none': isPrintMode}"
        :item="currentItem" 
        :fullscreen.sync="fullscreen" />
      
      <tj-info-dialog
        max-width="800px"
        v-model="showInfo"
        :icone="appIcon"
        :titulo="appTitle">

        <h3>{{appTitle}}</h3>
        <h5 class="text-uppercase">{{appSubTitle}}</h5>

        <v-divider class="my-2" />

        <p>
          A CCIAM através da Secretaria de Informática operacionalizou o Banco de Decisões e Sentenças do TJPA,
          com o objetivo precípuo de alinhar-se à estratégia nacional do judiciário no macrodesafio “agilidade 
          e produtividade na prestação jurisdicional”, bem como ao Plano de Gestão do Biênio 2021/2023.
        </p>

        <p>
          O objetivo é a materialização, na prática judiciária, do comando constitucional da razoável 
          duração do processo. 
        </p>

        <p>
          Trata-se de uma nova ferramenta disponibilizada aos magistrados e magistradas, que visa à otimização do
          trabalho e consequente elevação da produtividade com eficiente entrega aos jurisdicionados.   
        </p>

        <p>
          O Banco de Decisões e Sentenças operará de forma automática, integrado ao PJe, disponibilizando busca 
          por classe, assunto, competência ou texto da sentença, resguardados os processos identificados 
          como sigilosos.
        </p>
      </tj-info-dialog>

      <tj-nav-drawer v-model="showDrawer" width="400" :titulo="appTitle">
          <tj-facet-list 
            :facets="facets" 
            @filter="onFilter" 
            @close="onCloseFacet" 
            @close-all="onCloseAllFacets" 
            @open-all="onOpenAllFacets" />
      </tj-nav-drawer>
    </div>
    <div v-if="isPrintMode" class="d-none d-print-block">
      <tj-item-full :item="currentItem" />
    </div>
  </v-app>
</template>

<script>
import "./views/tj-app.vue";
import "./components/tj-nav-drawer.vue"
import "./components/tj-facet-list.vue"
import "./components/tj-tool-bar-bg.vue"
import './components/tj-sentenca-dialog.vue';
import "./components/tj-info-dialog.vue"
import "./components/tj-item-full.vue"

import {cmd, api} from "./service/app-state.js"
import tjItemFull from './components/tj-item-full.vue';

const APP_NAME = "banco-de-sentencas"

export default {
  components: { tjItemFull },
  data() {
    return {
      appTitle: "Suscitação de Dúvida - Registros Públicos",
      appSubTitle: "Banco de Decisões e Sentenças do TJPA",
      appIcon: "/img/logo-suscitacao-duvida.png",
      showDrawer: false,
      showSentenca: false,
      showInfo: false,
    };
  },

  computed: {
    config(){
      return this.$store.getters.config
    },

    darkMode: {
      get(){
        return this.$store.state.darkMode
      },
      set(v){
        this.$store.commit(cmd.SET_DARK_MODE, v)
      }
    },

    showFilters: {
      get(){
        return this.$store.state.showFilters
      },
      set(v){
        this.$store.commit(cmd.SET_SHOW_FILTERS, v)
      }
    },

    fullscreen: {
      get(){
        return this.$store.state.fullscreen
      },
      set(v){
        this.$store.commit(cmd.SET_FULLSCREEN, v);
      }
    },

    currentItem: {
      get(){
        return this.$store.state.currentItem
      },
      set(v){
        this.$store.commit(cmd.SET_CURRENT_ITEM, v)
      }
    },

    facets(){
      return this.$store.getters.formatedFacets
    },

    isPrintMode(){
      return this.showSentenca //&& this.fullscreen
    }

  },

  watch: {
    config(v){
      this.saveConfig(v)
    },

    darkMode(v){
      this.setDarkMode(v)
    }
  },

  methods: {

    saveConfig(config){
      let v = JSON.stringify(config)
      console.log("saveConfig", v)
      window.localStorage.setItem(APP_NAME, v)
    },

    setDarkMode(v){
      this.$vuetify.theme.dark = v
    },

    onFilter({key, value, state}){
      let facet = this.$store.getters.getFacetById(key)
      this.$store.dispatch(api.ADD_REMOVE_FILTER, {facet, filter: value, value:state})
    },

    onNavIconClick(){
      this.showDrawer = !this.showDrawer;
    },

    onViewItem(item){
      this.currentItem = item;
      this.showSentenca = true;
    },

    onCloseFacet(facet, closed){
      this.$store.commit(cmd.CLOSE_FACET, {facet, closed})
    },

    onCloseAllFacets(){
      this.$store.commit(cmd.CLOSE_ALL_FACETS)
    },

    onOpenAllFacets(){
      this.$store.commit(cmd.OPEN_ALL_FACETS)
    },

    onToggleDarkMode(){
      this.darkMode = !this.darkMode
    },

    onShowInfo(){
      this.showInfo = true
    },

    onStateChange(){
      this.$vuetify.goTo(0)
    }

  },

  created(){
    window.xApp = this;
    const config = window.localStorage.getItem(APP_NAME);
    if(config) this.$store.commit(cmd.INIT, JSON.parse(config))
    this.setDarkMode(this.darkMode)
  },

};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: Roboto, Oxygen-Sans, Ubuntu, Cantarell, BlinkMacSystemFont,
    "Segoe UI", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.with-bg {
  background-color: #190C22 !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1478' height='1478' viewBox='0 0 800 800'%3E%3Cg fill='none' stroke-opacity='0.31'%3E%3Cg stroke='%23120066' stroke-width='17'%3E%3Cline x1='-8' y1='-8' x2='808' y2='808'/%3E%3Cline x1='-8' y1='792' x2='808' y2='1608'/%3E%3Cline x1='-8' y1='-808' x2='808' y2='8'/%3E%3C/g%3E%3Cg stroke='%23120167' stroke-width='16'%3E%3Cline x1='-8' y1='767' x2='808' y2='1583'/%3E%3Cline x1='-8' y1='17' x2='808' y2='833'/%3E%3Cline x1='-8' y1='-33' x2='808' y2='783'/%3E%3Cline x1='-8' y1='-783' x2='808' y2='33'/%3E%3C/g%3E%3Cg stroke='%23120168' stroke-width='15'%3E%3Cline x1='-8' y1='742' x2='808' y2='1558'/%3E%3Cline x1='-8' y1='42' x2='808' y2='858'/%3E%3Cline x1='-8' y1='-58' x2='808' y2='758'/%3E%3Cline x1='-8' y1='-758' x2='808' y2='58'/%3E%3C/g%3E%3Cg stroke='%23130269' stroke-width='14'%3E%3Cline x1='-8' y1='67' x2='808' y2='883'/%3E%3Cline x1='-8' y1='717' x2='808' y2='1533'/%3E%3Cline x1='-8' y1='-733' x2='808' y2='83'/%3E%3Cline x1='-8' y1='-83' x2='808' y2='733'/%3E%3C/g%3E%3Cg stroke='%2313036a' stroke-width='13'%3E%3Cline x1='-8' y1='92' x2='808' y2='908'/%3E%3Cline x1='-8' y1='692' x2='808' y2='1508'/%3E%3Cline x1='-8' y1='-108' x2='808' y2='708'/%3E%3Cline x1='-8' y1='-708' x2='808' y2='108'/%3E%3C/g%3E%3Cg stroke='%2313036b' stroke-width='12'%3E%3Cline x1='-8' y1='667' x2='808' y2='1483'/%3E%3Cline x1='-8' y1='117' x2='808' y2='933'/%3E%3Cline x1='-8' y1='-133' x2='808' y2='683'/%3E%3Cline x1='-8' y1='-683' x2='808' y2='133'/%3E%3C/g%3E%3Cg stroke='%2313046c' stroke-width='11'%3E%3Cline x1='-8' y1='642' x2='808' y2='1458'/%3E%3Cline x1='-8' y1='142' x2='808' y2='958'/%3E%3Cline x1='-8' y1='-158' x2='808' y2='658'/%3E%3Cline x1='-8' y1='-658' x2='808' y2='158'/%3E%3C/g%3E%3Cg stroke='%2314056d' stroke-width='10'%3E%3Cline x1='-8' y1='167' x2='808' y2='983'/%3E%3Cline x1='-8' y1='617' x2='808' y2='1433'/%3E%3Cline x1='-8' y1='-633' x2='808' y2='183'/%3E%3Cline x1='-8' y1='-183' x2='808' y2='633'/%3E%3C/g%3E%3Cg stroke='%2314066e' stroke-width='9'%3E%3Cline x1='-8' y1='592' x2='808' y2='1408'/%3E%3Cline x1='-8' y1='192' x2='808' y2='1008'/%3E%3Cline x1='-8' y1='-608' x2='808' y2='208'/%3E%3Cline x1='-8' y1='-208' x2='808' y2='608'/%3E%3C/g%3E%3Cg stroke='%23140770' stroke-width='8'%3E%3Cline x1='-8' y1='567' x2='808' y2='1383'/%3E%3Cline x1='-8' y1='217' x2='808' y2='1033'/%3E%3Cline x1='-8' y1='-233' x2='808' y2='583'/%3E%3Cline x1='-8' y1='-583' x2='808' y2='233'/%3E%3C/g%3E%3Cg stroke='%23140771' stroke-width='7'%3E%3Cline x1='-8' y1='242' x2='808' y2='1058'/%3E%3Cline x1='-8' y1='542' x2='808' y2='1358'/%3E%3Cline x1='-8' y1='-558' x2='808' y2='258'/%3E%3Cline x1='-8' y1='-258' x2='808' y2='558'/%3E%3C/g%3E%3Cg stroke='%23140872' stroke-width='6'%3E%3Cline x1='-8' y1='267' x2='808' y2='1083'/%3E%3Cline x1='-8' y1='517' x2='808' y2='1333'/%3E%3Cline x1='-8' y1='-533' x2='808' y2='283'/%3E%3Cline x1='-8' y1='-283' x2='808' y2='533'/%3E%3C/g%3E%3Cg stroke='%23140973' stroke-width='5'%3E%3Cline x1='-8' y1='292' x2='808' y2='1108'/%3E%3Cline x1='-8' y1='492' x2='808' y2='1308'/%3E%3Cline x1='-8' y1='-308' x2='808' y2='508'/%3E%3Cline x1='-8' y1='-508' x2='808' y2='308'/%3E%3C/g%3E%3Cg stroke='%23150a74' stroke-width='4'%3E%3Cline x1='-8' y1='467' x2='808' y2='1283'/%3E%3Cline x1='-8' y1='317' x2='808' y2='1133'/%3E%3Cline x1='-8' y1='-333' x2='808' y2='483'/%3E%3Cline x1='-8' y1='-483' x2='808' y2='333'/%3E%3C/g%3E%3Cg stroke='%23150b75' stroke-width='3'%3E%3Cline x1='-8' y1='342' x2='808' y2='1158'/%3E%3Cline x1='-8' y1='442' x2='808' y2='1258'/%3E%3Cline x1='-8' y1='-458' x2='808' y2='358'/%3E%3Cline x1='-8' y1='-358' x2='808' y2='458'/%3E%3C/g%3E%3Cg stroke='%23150c76' stroke-width='2'%3E%3Cline x1='-8' y1='367' x2='808' y2='1183'/%3E%3Cline x1='-8' y1='417' x2='808' y2='1233'/%3E%3Cline x1='-8' y1='-433' x2='808' y2='383'/%3E%3Cline x1='-8' y1='-383' x2='808' y2='433'/%3E%3C/g%3E%3Cg stroke='%23150D77' stroke-width='1'%3E%3Cline x1='-8' y1='392' x2='808' y2='1208'/%3E%3Cline x1='-8' y1='-408' x2='808' y2='408'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
}
</style>
